import { Compass, MessageSquareQuote, Sparkles } from "lucide-react";

/* Hand-rolled iPhone mockup so we don't depend on photographic assets */
export default function PhoneMockup({ className = "" }) {
  return (
    <div className={`relative ${className}`} data-testid="phone-mockup">
      <div className="relative w-[280px] sm:w-[320px] md:w-[340px] aspect-[9/19.5] mx-auto">
        {/* glow */}
        <div className="absolute -inset-12 gold-glow blur-2xl opacity-80" aria-hidden />

        {/* device frame */}
        <div className="absolute inset-0 rounded-[44px] bg-[#0A0A0A] border border-white/10 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.9)] p-2">
          <div className="absolute inset-x-0 top-0 mx-auto mt-1.5 h-6 w-32 rounded-full bg-black z-20 border border-white/5" aria-hidden />
          <div className="absolute inset-y-20 -left-[2px] w-[2px] bg-white/10" aria-hidden />
          <div className="absolute inset-y-32 -right-[2px] w-[2px] bg-white/10" aria-hidden />

          {/* screen */}
          <div className="relative h-full w-full rounded-[36px] overflow-hidden bg-gradient-to-b from-[#0E0B06] via-[#0A0807] to-[#050505]">
            {/* status bar */}
            <div className="flex items-center justify-between px-6 pt-3 text-[10px] text-bone/60 tracking-wide">
              <span>9:41</span>
              <span className="flex gap-1.5 items-center">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" />
                <span className="h-1.5 w-1.5 rounded-full bg-bone/40" />
                <span className="h-1.5 w-1.5 rounded-full bg-bone/40" />
              </span>
            </div>

            {/* header */}
            <div className="px-6 mt-8">
              <p className="text-[9px] tracking-[0.3em] uppercase text-gold">Virtue Guide</p>
              <h3 className="font-serif text-3xl text-bone leading-tight mt-1">
                Good morning,<br/>Aurelius.
              </h3>
              <p className="mt-3 text-[11px] text-bone/55 leading-relaxed font-light">
                Today's reflection: <span className="text-gold/90">temperance</span>.
              </p>
            </div>

            <div className="mx-6 mt-6 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

            {/* dialogue */}
            <div className="px-5 mt-6 space-y-3">
              <div className="bg-white/[0.04] border border-white/5 rounded-2xl rounded-tl-sm p-3">
                <div className="flex items-center gap-2 mb-1.5">
                  <Compass size={11} color="#C5A059" strokeWidth={1.5} />
                  <span className="text-[9px] tracking-[0.18em] uppercase text-gold">Marcus</span>
                </div>
                <p className="font-serif italic text-[13px] text-bone/90 leading-snug">
                  "Confine yourself to the present."
                </p>
              </div>

              <div className="bg-gold/[0.08] border border-gold/20 rounded-2xl rounded-tr-sm p-3 ml-8">
                <p className="text-[11px] text-bone/85 font-light leading-snug">
                  How do I quiet the noise of the day before I begin?
                </p>
              </div>

              <div className="bg-white/[0.04] border border-white/5 rounded-2xl rounded-tl-sm p-3">
                <div className="flex items-center gap-2 mb-1.5">
                  <MessageSquareQuote size={11} color="#C5A059" strokeWidth={1.5} />
                  <span className="text-[9px] tracking-[0.18em] uppercase text-gold">Guide</span>
                </div>
                <p className="text-[11px] text-bone/80 font-light leading-snug">
                  Begin with one breath. Then ask: what is mine to do, and what is not?
                </p>
              </div>
            </div>

            {/* input */}
            <div className="absolute bottom-6 inset-x-5">
              <div className="flex items-center gap-2 bg-white/[0.04] border border-white/10 rounded-full px-4 py-2.5">
                <Sparkles size={12} color="#C5A059" strokeWidth={1.5} />
                <span className="text-[10px] text-bone/40 tracking-wide">Speak with the guide...</span>
              </div>
            </div>
          </div>
        </div>

        {/* highlight */}
        <div className="pointer-events-none absolute -inset-px rounded-[44px] bg-gradient-to-b from-white/10 via-transparent to-transparent opacity-60" aria-hidden />
      </div>
    </div>
  );
}
